import DTMHandler from 'dgad-analytics/src/adobe/DTMHandler.class'
import DTMRule from 'dgad-analytics/src/adobe/DTMRule.class'
import { getCurrentAndPreviousUrl } from '../../../../node_modules/dgad-vue-common/src/router'
import { getRecapSearchFilters } from 'dgad-vue-dealer-locator-widgets/src/lib/filters'
import { ROUTE_NAMES } from 'dgad-vue-dealer-locator-widgets/src/router/routes'

const PAGEINFO_UPDATED = 'PAGEINFO_UPDATED'
const DL_CLICK_ADDRESS_SUGGESTION = 'DL_CLICK_ADDRESS_SUGGESTION'
const DL_CLICK_GEOLOC = 'DL_CLICK_GEOLOC'
const DL_CLICK_MARKER = 'DL_CLICK_MARKER'
const DL_CLICK_DEALER_PHONE = 'DL_CLICK_DEALER_PHONE'
const DL_CLICK_DEALER_ADDRESS = 'DL_CLICK_DEALER_ADDRESS'
const DL_TOGGLE_FILTERS = 'DL_TOGGLE_FILTERS'
const DL_CLICK_FILTER = 'DL_CLICK_FILTER'

const dtmRules = {
  /**
   * DL Search Page
   * Page loading
   */
  DL_SEARCH_PAGE: new DTMRule(PAGEINFO_UPDATED, {
    eventInfo: {
      events: 'event86,event87'
    },
    pageInfo: {
      pagename: 'dealer-locator/search',
      sitesection: 'dealer-locator',
      loadingtime: null,
      dealerid: false,
      dlsearchtype: false,
      dlsearchphrase: false,
      recapsearchfilters: false,
      resultnumber: false,
      dltypedsearchphrase: false,
      dealerlistviewmode: false
    }
  }),
  /**
   * Dealer locator no results page
   * page loading
   */
  DL_NO_RESULT: new DTMRule(PAGEINFO_UPDATED, {
    eventInfo: {
      events: 'event86,event87,event79,event80'
    },
    pageInfo: {
      pagename: 'dealer-locator/no-results',
      sitesection: 'dealer-locator',
      loadingtime: null,
      dealerid: false,
      dlsearchtype: null,
      dlsearchphrase: null, // [Value selected by the user]
      recapsearchfilters: null, // [the selected distance range and list of selected filters]  (if available)
      resultnumber: 0,
      dltypedsearchphrase: null, // [typed search phrase if available]
      dealerlistviewmode: false
    }
  }),
  /**
   * Dealer locator results page
   * page loading
   */
  DL_RESULTS: new DTMRule(PAGEINFO_UPDATED, {
    eventInfo: {
      events: 'event86,event87,event16,event66,event51'
    },
    pageInfo: {
      pagename: 'dealer-locator/results',
      sitesection: 'dealer-locator',
      loadingtime: null,
      dealerid: null, // [dealer id /dealer id /…]
      dlsearchtype: null,
      dlsearchphrase: null, // [Value selected by the user]
      recapsearchfilters: null, // [the selected distance range and list of selected filters]  (if available)
      resultnumber: null, // [number of results returned by the research]
      dltypedsearchphrase: null, // [typed search phrase if available]
      dealerlistviewmode: null // [map mode / list mode /map list mode] (if available)
    }
  }),
  /**
   * Select a value in the open search results list
   * When a user clicks on a suggested result in the open search results list
   */
  [DL_CLICK_ADDRESS_SUGGESTION]: new DTMRule(DL_CLICK_ADDRESS_SUGGESTION, {
    eventInfo: {
      events: 'event19',
      interactionobject: 'dealer-locator',
      componentinteractedwith: 'DL location search',
      dlsearchtype: 'search phrase',
      dlsearchphrase: null, // [Value selected by the user]
      dltypedsearchphrase: null // [typed search phrase if available]
    }
  }),
  /**
   * Geoloc CTA
   * When a user clicks on geoloc CTA
   */
  [DL_CLICK_GEOLOC]: new DTMRule(DL_CLICK_GEOLOC, {
    eventInfo: {
      events: 'event19',
      interactionobject: 'dealer-locator',
      componentinteractedwith: 'DL geoloc search',
      dlsearchtype: 'geolocalization'
    }
  }),
  /**
   * Click a POS indicator on a map
   * when a user clicks on a indicator on a map
   */
  [DL_CLICK_MARKER]: new DTMRule(DL_CLICK_MARKER, {
    eventInfo: {
      events: 'event38',
      dealerid: null,
      interactionobject: 'dealer-locator',
      componentinteractedwith: 'click POS'
    }
  }),
  /**
   * Call the dealer button (opens the phone keyboard)
   * user clicks on the dealer's phone number to call
   */
  [DL_CLICK_DEALER_PHONE]: new DTMRule(DL_CLICK_DEALER_PHONE, {
    eventInfo: {
      events: 'event23',
      dealerid: null,
      interactionobject: 'dealer-locator',
      componentinteractedwith: 'call dealer'
    }
  }),
  /**
   * DL Get direction
   * user clicks on the dealer address to get navigation
   */
  [DL_CLICK_DEALER_ADDRESS]: new DTMRule(DL_CLICK_DEALER_ADDRESS, {
    eventInfo: {
      events: 'event38',
      dealerid: null,
      interactionobject: 'dealer-locator',
      componentinteractedwith: 'show itinerary'
    }
  }),
  /**
   * Open/close filters
   * when a user clicks on the filter button to open the filter/sort overlay or click on the cross on the overlay to close it
   */
  [DL_TOGGLE_FILTERS]: new DTMRule(DL_TOGGLE_FILTERS, {
    eventInfo: {
      events: 'event38',
      interactionobject: 'dealer-locator',
      componentinteractedwith: null // "[open/close] filters"
    }
  }),
  /**
   * Select / Unselect Filter
   * when a user clicks select/unselect a filter
   */
  [DL_CLICK_FILTER]: new DTMRule(DL_CLICK_FILTER, {
    eventInfo: {
      events: 'event38',
      interactionobject: 'dealer-locator',
      componentinteractedwith: null, // "[select/unselect] filter"
      recapsearchfilters: null
    }
  })
}

/**
 * Map generic values with
 * BFG specific ones.
 */
const VALUES_PATHS_MAP = {
  [DL_CLICK_ADDRESS_SUGGESTION]: {
    selected: 'eventInfo.dlsearchphrase',
    typed: 'eventInfo.dltypedsearchphrase'
  },
  [DL_CLICK_MARKER]: {
    dealerId: 'eventInfo.dealerid'
  },
  [DL_CLICK_DEALER_PHONE]: {
    dealerId: 'eventInfo.dealerid'
  },
  [DL_CLICK_DEALER_ADDRESS]: {
    dealerId: 'eventInfo.dealerid'
  },
  [DL_TOGGLE_FILTERS]: {
    action: 'eventInfo.componentinteractedwith'
  },
  [DL_CLICK_FILTER]: {
    action: 'eventInfo.componentinteractedwith',
    selected: 'eventInfo.recapsearchfilters'
  }
}

/**
 * Update Data Layer.
 * @param {Object} context
 * @param {Store} context.store
 * @param {VueRouter} context.router
 * @param {Object} context.to
 * @param {Object} context.from
 * @param {Object} options
 * @param {Boolean} options.triggerHit
 * @param {Boolean} options.changeUrl
 * @param {Object} options.pageInfo
 */
const analyticsRouteUpdate = ({ store, router, to, from }, { triggerHit, changeUrl, pageInfo = {} }) => {
  try {
    const isSearchPage = (router.currentRoute.name === ROUTE_NAMES.SEARCH)
    const isResultPage = (router.currentRoute.name === ROUTE_NAMES.RESULT)

    // Add referring url
    if (changeUrl) {
      const { current, previous } = getCurrentAndPreviousUrl(router.options.base, to, from)
      pageInfo.pageurl = current
      pageInfo.referringurl = previous
    }

    let dtmRule
    if (isSearchPage) {
      dtmRule = dtmRules.DL_SEARCH_PAGE
    } else if (isResultPage) {
      const state = store.state.dealerLocator
      const dealers = state.dealers.dealers

      // Take values set by the user from previous event
      const dataLayer = DTMHandler.instance.dataLayer
      pageInfo.dlsearchtype = dataLayer.tags.eventInfo.dlsearchtype
      pageInfo.dlsearchphrase = dataLayer.tags.eventInfo.dlsearchphrase

      pageInfo.recapsearchfilters = getRecapSearchFilters(state)
      pageInfo.dltypedsearchphrase = state.search.input

      if (dealers && dealers.length) {
        pageInfo.dealerid = `${dealers.map(dealer => dealer.id).join('/')}`
        pageInfo.resultnumber = dealers.length
        pageInfo.dealerlistviewmode = state.activeMobileTab
        dtmRule = dtmRules.DL_RESULTS
      } else {
        dtmRule = dtmRules.DL_NO_RESULT
      }
    }

    pageInfo.loadingtime = window.DTMLoadTime.calculate()

    dtmRule
      .update({ pageInfo })
      .updateDataLayer()

    triggerHit && dtmRule.fire()
  } catch (err) {
    console.error(err)
  }
}

window.addEventListener('DL_EVENT', event => {
  if (!DTMHandler.instance) return

  const { id, data } = event.detail

  const rule = dtmRules[id]
  const mapping = VALUES_PATHS_MAP[id]

  Object.keys(data).forEach(key => {
    const value = data[key]
    const path = mapping[key]
    rule.dataLayer.set(path, value)
  })

  rule.updateDataLayer()
  rule.fire()
})

window.addEventListener('DL_ROUTE_UPDATE', event => {
  if (!DTMHandler.instance) return

  const { data } = event.detail
  const { context, options } = data
  analyticsRouteUpdate(context, options)
})



// WEBPACK FOOTER //
// ./lib/modules/dgad-vue-dealer-locator-widgets/src/entry-client-analytics.js